<div class="dates-wrapper"
  *ngIf="((isApptLoading$ | async) && (isSettingsLoading$ | async) && (isTeamsLoading$ | async) && (isSlotLoading$ | async)  && (isVehiclesLoading$ | async)); else loader">
  <div class="view-container">
    <!-- Generated by Copilot- Start -->
    <div class="dispatch-calendar-scroll" *ngIf="events.length > 0">
      <app-custom-calendar-day-view
      [viewDate]="viewDate"
      [events]="events"
      [minimumEventCardWidth]="minimumDispatchCardWidth"
      [maximumEventCardWidth]="maximumDispatchCardWidth"
      [stickyBottomScrollbar]="true"
      [refresh]="refresh"
      (eventTimesChanged)="eventTimesChanged($event)"
      (eventClicked)="eventClicked($event)"
      [hourSegments]="hourSplit"
      [dayStartHour]="dayStartHour"
      [snapDraggedEvents]="false"
      [dayEndHour]="dayEndHour"
      [eventTitleTemplate] = "customTitleTemplate"
      >
      </app-custom-calendar-day-view>
    </div>
    <!-- Generated by Copilot- End -->
    <div class="no-appointments" *ngIf='(events?.length === 0 && (isApptLoading$ | async))'>
      <mat-icon class="mat-icon">info_outline</mat-icon>
      <span class="label">{{ 'serviceSchedule.thereAreNoAppointmentsScheduledForTheDay' | translate }}</span>
    </div>
  </div>
</div>

<ng-template #loader>
    <div id="schedule-rotation-loader">
      <app-loading loadingSymbol="dots" text="{{'serviceSchedule.loadingAppointmentsForTheDay'| translate}}"
      color="var(--primary-sec-color)"></app-loading>
    </div>
  </ng-template>

 <ng-template #customTitleTemplate let-event="event" let-view="view">
  <div class="appointment-content"
    [style.width]="event.meta?.cardWidth ? event.meta.cardWidth : '100%'">
    <div class="appt-header-row">
      <strong>{{ getCustomerDisplayName(event.meta) }}</strong>
      <span *ngIf="hasTradeInIndicator(event)"
        class="trade-in-indicator"
        [ngClass]="{'icon-only': !shouldShowDispatchTradeInText(event)}"
        [matTooltip]="shouldShowDispatchTradeInText(event) ? '' : ('testDrive.tradeIn' | translate)"
        [matTooltipDisabled]="shouldShowDispatchTradeInText(event)"
        aria-label="Trade In"
        [title]="shouldShowDispatchTradeInText(event) ? '' : ('testDrive.tradeIn' | translate)"><span *ngIf="shouldShowDispatchTradeInText(event)">{{ 'testDrive.tradeIn' | translate }}</span></span>
    </div>
    <span class="transport"> {{getTranslationForTransportation(event.meta.transportationTypeCode)}} </span>
    <div class="status d-flex">
    <div class="status-indicators">
      <div *ngIf="department === 'SALES' ? isCrmIntegrated : isDmsIntegrated" class="sync-status">
        <div class="status-icon" [ngClass] = "{'success' : event.meta.syncStatus==='SYNC_COMPLETED' , 'failure' : event.meta.syncStatus==='SYNC_FAILURE','requested' : event.meta.syncStatus==='SYNC_REQUESTED'}" >
          <asp-icon name="ic-20-alert-tick.svg" path="svg/" height = "25px" width = "25px" *ngIf="event.meta.syncStatus==='SYNC_COMPLETED' && (event.meta?.appointmentCreatedBy !== 'DMS' && event.meta?.appointmentCreatedBy !== 'CRM')"></asp-icon>
          <asp-icon name="ic-20-utility-transfer.svg" path="" height = "25px" width = "25px" *ngIf="event.meta.syncStatus==='SYNC_COMPLETED' && (event.meta?.appointmentCreatedBy === 'DMS' || event.meta?.appointmentCreatedBy === 'CRM')"></asp-icon>
          <asp-icon name="ic-20-feedback-alert-error.svg" path="svg/" height = "25px" width = "25px" *ngIf="event.meta.syncStatus==='SYNC_FAILURE'"></asp-icon>
          <asp-icon name="arrow-forward.svg" height = "25px" width = "25px" *ngIf="event.meta.syncStatus==='SYNC_REQUESTED'"></asp-icon>
        </div>
      </div>

      <div *ngIf="department === 'SALES' && event.meta.deletePending" class="sync-status vehicle-unavailable-indicator">
        <asp-icon name="deleted-vehicle.svg" height = "25px" width = "25px" color="var(--primary-toyota-color)"></asp-icon>
      </div>
    </div>
  </div>
    {{event.meta.makeModelYear}}<br>
    {{ (department === 'SALES' ? 'serviceSchedule.consultant' : 'serviceSchedule.advisor') | translate}} : {{event.meta.advisor?.displayName || 'NA'}}
    
  </div>
</ng-template>
